export const STORIES_CONSTS = {
  actualStories: 'Актуальные',
  archivedStories: 'Архивные',
  deletedStories: 'Удаленные'
}
